import { Component, OnInit } from '@angular/core';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { AddfundPopupComponent } from 'src/app/addfund-popup/addfund-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-leftside',
  templateUrl: './leftSide.component.html',
  styleUrls: ['./leftSide.component.scss']
})
export class LeftSideComponent implements OnInit {
  currentUser : any;
  user_id = 0;
  user_name:string;
  drafters_id:string;
  seletedMenu:string;
  siteURL = `${environment.SITE_URL}`;
  assetURL = `${environment.assetURL}`;
  current_year = new Date().getFullYear();
  constructor(private router:Router,
    public dialog: MatDialog) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
      this.user_name = this.currentUser.username;
      this.drafters_id = this.currentUser.drafters_id;
    }
    if(router.url=='/user/refer-friend'){
      this.seletedMenu='ReferAFriend';
    }
  }
  openDialog(tab) {
    this.dialog.closeAll();
    const dialogRef =  this.dialog.open(AddfundPopupComponent, {
      width: '850px',
      data: { 'tab': tab}
    });
  }
  ngOnInit() {
  }

}
